module.exports = __webpack_public_path__ + "img/icone-beacon.0490ba69.svg";